import { render, staticRenderFns } from "./nextNews.vue?vue&type=template&id=6fceed48&scoped=true"
import script from "./nextNews.vue?vue&type=script&lang=js"
export * from "./nextNews.vue?vue&type=script&lang=js"
import style0 from "./nextNews.vue?vue&type=style&index=0&id=6fceed48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fceed48",
  null
  
)

export default component.exports